<template>
  <div id="rh-header-slot" :style="outerStyle">
    <ClickableBreadcrumbs id="breadcrumbs-container" class="desktop" />
    <TTReader id="header-story" hide-if-empty :panel="panel" data-cy="header-panel" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import TTReader from '@/components/TipTap/wrappers/TTReader.vue'
import ClickableBreadcrumbs from '@/components/public/ClickableBreadcrumbs.vue'
import { StoryKeys } from '@/types'
import { StyleValue } from 'vue/types/jsx'

const components = {
  TTReader,
  ClickableBreadcrumbs,
}

const props = {
  panel: {
    type: String,
    default: StoryKeys.ABOVE_BUBBLES,
  },
}

@Component({ components })
export default class HeaderPanel extends Vue.extend({ props }) {
  // MS IE Hack to fix bubble width issue
  get sidebarContainerWidth() {
    return this.$typedStore.public.size.sidebarContainerWidth
  }

  // MS IE Hack to fix bubble width issue
  get sidetabsContainerWidth() {
    return this.$typedStore.public.size.sidetabsContainerWidth
  }

  // MS IE Hack to fix bubble width issue
  get mainContentWidth() {
    return this.$typedStore.public.size.mainContentWidth
  }

  // MS IE Hack to fix bubble width issue
  get navButtonsWidth() {
    return this.$typedStore.public.size.navButtonsWidth
  }

  // MS IE Hack to fix bubble width issue
  get msieversion() {
    return this.$typedStore.public.size.msieversion
  }

  get activeVisualisationIsCustom() {
    return this.$typedStore.activeVisualisation.isCustom
  }

  get width() {
    const width =
      this.mainContentWidth -
      this.sidebarContainerWidth -
      this.sidetabsContainerWidth -
      this.navButtonsWidth
    return width > 0 ? width : 400
  }

  get outerStyle(): StyleValue {
    if (this.activeVisualisationIsCustom) {
      return {
        position: 'absolute',
        width: '100%',
        'z-index': 1,
      }
    } else {
      return {
        position: 'relative',
      }
    }
  }
}
</script>

<style lang="scss">
#rh-header-slot {
  max-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  #breadcrumbs-container {
    position: absolute;
    left: 13px;
    top: 3px;
    right: 80px;
    overflow-x: clip;
  }
  #header-story {
    margin-top: 50px;
    max-width: 70%;
  }
}
</style>
